import React, { useEffect, useRef } from 'react';
import { JuniorLayout } from '../../components/layout/JuniorLayout';
import { ActivityShell } from '../../components/activity/ActivityShell';
import { RequireJuniorSession } from '../../components/auth/RequireJuniorSession';
import { initMusicalCloudTetris } from '../../games/musical-cloud-tetris/game.js';
import '../../games/musical-cloud-tetris/musical-cloud-tetris.css';

function MusicalCloudTetrisInner() {
  const mountRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const root = mountRef.current;
    if (!root) return undefined;
    const cleanup = initMusicalCloudTetris(root);
    return cleanup;
  }, []);

  return (
    <JuniorLayout immersive>
      <ActivityShell
        title="Tetris Musical"
        subtitle=""
        backTo="/mini-juegos"
        backLabel="Mini juegos"
        lockViewport
        fullBleed
        immersive
      >
        <div className="mct-page mct-page-wrap flex flex-col flex-1 min-h-0 h-full overflow-hidden">
          <div ref={mountRef} className="flex-1 min-h-0 h-full overflow-hidden" />
        </div>
      </ActivityShell>
    </JuniorLayout>
  );
}

export default function MusicalCloudTetrisPage() {
  return (
    <RequireJuniorSession>
      <MusicalCloudTetrisInner />
    </RequireJuniorSession>
  );
}
